/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export class FormSection extends BaseGroup {
        constructor(formService: services.FormService,
            dataSourceService: services.DataSourceService,
            formSectionService: services.FormSectionService,
            modalSerivce: any) {
            super(formService, dataSourceService, formSectionService, modalSerivce);
        }

        public link($scope: directives.IFormSectionScope,
            element: JQuery,
            attrs: ng.IAttributes) { }

        public templateUrl = './app/views/directives/inputForm/formSection.html';
        public controller = ['$scope', 'formService', 'dataSourceService', 'formSectionService', 'ModalService','deleteService','securityMatrixService','$rootScope', FormSectionController];
    }

    export class FormSectionController extends BaseGroupController {
        constructor($scope: directives.IFormSectionScope,
            formService: services.FormService,
            dataSourceService: services.DataSourceService,
            formSectionService: services.FormSectionService,
            modalService: any,
            deleteService: services.DeleteService,
            securityMatrixService: services.SecurityMatrixService,
            private $rootScope: angular.IRootScopeService)
        {
            super($scope, formService, dataSourceService, formSectionService, modalService, deleteService,securityMatrixService);
            $scope.userActionInitiated = (u) => this.userActionInitiated(u);
            //if($scope.formSection.condition_id && $scope.process && !$scope.process.conditionStates[$scope.formSection.condition_id])
           // || ($scope.process.formsVisibilities[$scope.form.uniqueIdentifier] && Enumerable.from($scope.process.formsVisibilities[$scope.form.uniqueIdentifier].hiddenGroups).any(g=>g[))){
        }

        userActionInitiated(userAction: Wars.Domain.Model.Dtos.UserActionModelDto) {
            this.$rootScope.$broadcast('userActionInitated', userAction);
        }
    }
}

warsApp.registerDirective('FormSection', []); 